/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import showAlert from '../../../utils/alert';
import {
  formatCrewDropdownLabel,
  getSapBPNumber,
  buildCrewSelectValue
} from '../../../utils/formatCrewDisplay';
import { enrichCrewWithSapBP } from '../../../utils/enrichCrewWithSapBP';

const PartialSearchFieldComponent = ({
  setCrewData,
  setCrewindex,
  index,
  requiredField,
  autoFocus,
  category,
  placeholder,
  isDisabled,
  isClearable,
  label,
  resetFields,
  companyId,
  value,
  field, // { name, value, onChange, onBlur }
  form: { touched, errors,
    setFieldValue } // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
}) => {
  const [page, setPage] = useState(1);
  const [searchValue, setSearch] = useState('');
  const [selectedValue, setSelectedValue] = useState(buildCrewSelectValue(value));

  useEffect(() => {
    let cancelled = false;

    const syncSelectedValue = async () => {
      if (!value?.crewCode) {
        setSelectedValue(null);
        return;
      }

      if (getSapBPNumber(value)) {
        setSelectedValue(buildCrewSelectValue(value));
        return;
      }

      const enriched = await enrichCrewWithSapBP(value, {
        companyId,
        expenseCategoryID: category?.expenseCategoryID || ''
      });

      if (cancelled) return;

      const sapBPNumber = getSapBPNumber(enriched);
      if (sapBPNumber) {
        setFieldValue(`purchaseOrderCrew[${index}].sapBPNumber`, sapBPNumber);
      }
      setSelectedValue(buildCrewSelectValue(enriched));
    };

    syncSelectedValue();

    return () => {
      cancelled = true;
    };
  }, [
    value?.crewCode,
    value?.firstName,
    value?.lastName,
    value?.rankName,
    value?.positionName,
    value?.sapBPNumber,
    companyId,
    category?.expenseCategoryID,
    index
  ]);

  const handleOnChange = (e) => {
    if (category?.categoryName === 'PPE' && e?.crewCode) {
    if (e?.rankId === null || e?.rankId === '' || e?.rankId === undefined) {
      showAlert('The selected Crew does not have Rank Id information. Kindly assign the Rank Id and proceed.', 'error');
      return;
    } if (e?.gender === null || e?.gender === '' || e?.gender === undefined) {
      showAlert('The selected Crew does not have Gender information. Kindly assign the Gender and proceed.', 'error');
      return;
    } if (e?.rankCategory === null || e?.rankCategory === '' || e?.rankCategory === undefined) {
      showAlert('The selected Crew does not have rank Category Name. Kindly assign the rank Category Name and proceed.', 'error');
      return;
    }
  }
    if (!e) {
      setSelectedValue(null);
      setCrewindex(index);
      setCrewData(null);
      if (typeof resetFields === 'function') {
        resetFields(index);
      }
      return;
    }
    if (value?.crewCode !== e?.crewCode) {
      setCrewData(e);
      setCrewindex(index);
    }
    setSelectedValue(buildCrewSelectValue(e));
  };
  // async function loadOptions(inputValue, { page }) {
    const loadOptions = async (search) => {
      if (search?.length > 0) {
        const regex = /^[a-zA-Z0-9\s/()-]*$/;
        if (!regex.test(search)) {
          showAlert('Please enter a valid Crew Code or SAP BP Number', 'error');
          return {
            options: [],
            hasMore: false
          };
        }
      }
      try {
        let res;
        const payload = {
          search,
          page: 1,
          pageSize: 50,
          expenseCategoryID: category?.expenseCategoryID ? category?.expenseCategoryID : '',
          companyId: companyId || 0
        };
        if (search?.length > 3) {
          if (search !== searchValue) {
            payload.page = 1;
            res = await axios.get(
              `${apiurl?.getPartialSearch}?searchCriteria=${payload?.search}&page=${payload?.page}&pageSize=${payload?.pageSize}&expenseCategoryID=${payload?.expenseCategoryID}&companyId=${payload?.companyId}`
            );
            setSearch(search);
            setPage(2);
          } else {
            payload.page = 1;
            res = await axios.get(
              `${apiurl?.getPartialSearch}?searchCriteria=${payload?.search}&page=${payload?.page}&pageSize=${payload?.pageSize}&expenseCategoryID=${payload?.expenseCategoryID}&companyId=${payload?.companyId}`
            );
            setPage(2);
          }
        }
        if (res?.data?.items?.length) {
          return {
            options: res?.data?.items.map((item) => {
              const option = {
                value: item?.uuid,
                crewCode: item.crewCode ? item.crewCode : item?.externalId,
                rankName: item?.rankName,
                age: item?.age,
                firstName: item?.firstName,
                lastName: item?.lastName,
                rankId: item?.rankId,
                rankCategory: item?.rankCategoryName,
                gender: item?.genderName,
                dateOfBirth: item?.dateOfBirth,
                positionName: item?.positionName,
                sapBPNumber: getSapBPNumber(item)
              };
              return {
                ...option,
                label: formatCrewDropdownLabel(option)
              };
            }),
            hasMore: res?.data?.hasNext
          };
        }
        if (res?.data?.hasNext) {
          setPage(res?.data?.currentPage + 1);
        }
        return {
          options: [],
          hasMore: false
        };
      } catch (error) {
        showAlert('Oops! Something went wrong. Please contact administrator for assistance.', 'error');
        return {
          options: [],
          hasMore: false
        };
      }
    };
    useEffect(() => {
      if (companyId || category) {
        setSearch('');
      }
    }, [companyId, category]);
  return (
    <div className={` ${requiredField ? 'required-field' : ''}`}>
      <label htmlFor={field.name}>{label}</label>
      <AsyncPaginate
        key={`${companyId}-${category?.expenseCategoryID || ''}`}
        className="pt-1 react-select-container"
        debounceTimeout={500}
        classNamePrefix="react-select-async"
        autoFocus={autoFocus}
        isClearable={isClearable}
        value={selectedValue}
        placeholder={placeholder}
        isDisabled={isDisabled}
        onChange={handleOnChange}
        getOptionLabel={(option) => option?.label || formatCrewDropdownLabel(option)}
        formatOptionLabel={(option) => option?.label || formatCrewDropdownLabel(option)}
        getOptionValue={(option) => option?.crewCode || option?.value || option?.label}
        filterOption={() => true}
        loadOptions={loadOptions}
        openMenuOnClick={false}
        noOptionsMessage={() => 'Crew not found'}
        components={{
          DropdownIndicator: null
        }}
      />
    </div>
  );
};

export default PartialSearchFieldComponent;
